import axiosClient from './axiosClient';

// Creditos otorgados a clientes (empresa con RUC o persona con DNI), ver CustomerCreditController.
const customerCreditsApi = {
  getCredits: (params) => axiosClient.get('/customer-credits', { params }),
  getCredit: (id) => axiosClient.get(`/customer-credits/${id}`),
  createCredit: (data) => axiosClient.post('/customer-credits', data),
  updateCredit: (id, data) => axiosClient.put(`/customer-credits/${id}`, data),
  deleteCredit: (id) => axiosClient.delete(`/customer-credits/${id}`),
};

export default customerCreditsApi;
